
import { defineComponent, computed } from 'vue'
import { faMousePointer } from '@fortawesome/free-solid-svg-icons'

import CommonLabel from '@/components/common/CommonLabel.vue'
import CommonPageHeading from '@/components/common/CommonPageHeading.vue'

export default defineComponent({
  components: {
    CommonLabel,
    CommonPageHeading
  },
  setup (_, { emit }) {
    const profileData = computed(() => [
      {
        title: 'Name',
        information: 'Takeuchi Takuto'
      },
      {
        title: 'Background',
        information: 'Bachelor of International Economics / Hosei University'
      },
      {
        title: 'Qiita',
        information: 'taku-hu',
        link: 'https://qiita.com/taku-hu'
      },
      {
        title: 'Github',
        information: 'taku-hu',
        link: 'https://github.com/taku-hu'
      },
      {
        title: 'wantedly',
        information: 'Takeuchi Takuto',
        link: 'https://www.wantedly.com/users/124833407'
      },
      {
        title: 'Contact',
        information: 'hs.tm.ec.a.tt@gmail.com'
      }
    ])

    const icons = computed(() => ({ faMousePointer }))

    const monthNames = [
      'Janualy',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December'
    ]
    const date = new Date()
    const now = computed(() => ({
      year: date.getFullYear(),
      month: monthNames[date.getMonth()],
      day: date.getDate()
    }))
    const suffix = computed(() => {
      const date = now.value.day
      if ([1, 21, 31].includes(date)) {
        return 'st'
      } else if ([2, 22].includes(date)) {
        return 'nd'
      } else if ([3, 23].includes(date)) {
        return 'rd'
      } else {
        return 'th'
      }
    })

    const changeTheme = () => emit('change-theme')

    return {
      profileData,
      icons,
      now,
      suffix,
      changeTheme
    }
  }
})
